import React, { useState, useEffect } from 'react';
import Sidebar from '../components/sidebar';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import axios from 'axios';

const NetworkLeadershipAcademy = () => {
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [users, setUsers] = useState({});

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem('loginUser');
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
    }
    // Cargar la URL existente
    fetchUrl();
  }, []);

  const fetchUrl = async () => {
    try {
      const response = await axios.get('https://api.mrcirp.com/public/network-leadership-academy');
      if (response.data && response.data[0] && response.data[0].url) {
        setUrl(response.data[0].url);
      }
    } catch (error) {
      console.error('Error fetching URL:', error);
      // Si no existe, no es un error crítico
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError(null);

    try {
      // Validar que sea una URL válida
      if (url && !isValidUrl(url)) {
        setError('Por favor ingresa una URL válida (debe comenzar con http:// o https://)');
        setLoading(false);
        return;
      }

      const response = await axios.post('https://api.mrcirp.com/public/network-leadership-academy', {
        url: url
      });

      if (response.data) {
        setSuccess(true);
        setTimeout(() => setSuccess(false), 3000);
      }
    } catch (err) {
      console.error('Error saving URL:', err);
      setError(err.response?.data?.message || 'Error al guardar la URL');
    } finally {
      setLoading(false);
    }
  };

  const isValidUrl = (string) => {
    try {
      const urlObj = new URL(string);
      return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
    } catch (_) {
      return false;
    }
  };

  const handleTestUrl = () => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  return (
    <Sidebar>
      <div className="container mt-4">
        <Card>
          <Card.Header className="bg-dark text-white">
            <h4 className="mb-0">Network Leadership Academy</h4>
          </Card.Header>
          <Card.Body>
            {success && (
              <Alert variant="success" onClose={() => setSuccess(false)} dismissible>
                URL guardada exitosamente
              </Alert>
            )}
            {error && (
              <Alert variant="danger" onClose={() => setError(null)} dismissible>
                {error}
              </Alert>
            )}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>URL del Network Leadership Academy</Form.Label>
                <Form.Control
                  type="url"
                  placeholder="https://ejemplo.com/network-leadership-academy"
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                  required
                />
                <Form.Text className="text-muted">
                  Ingresa la URL completa donde se encuentra el Network Leadership Academy
                </Form.Text>
              </Form.Group>

              <div className="d-flex gap-2">
                <Button variant="primary" type="submit" disabled={loading}>
                  {loading ? 'Guardando...' : 'Guardar URL'}
                </Button>
                {url && (
                  <Button variant="outline-secondary" type="button" onClick={handleTestUrl}>
                    Probar URL
                  </Button>
                )}
              </div>
            </Form>

            {url && (
              <div className="mt-4">
                <Card className="bg-light">
                  <Card.Body>
                    <h6>URL actual:</h6>
                    <p className="mb-0">
                      <a href={url} target="_blank" rel="noopener noreferrer">
                        {url}
                      </a>
                    </p>
                  </Card.Body>
                </Card>
              </div>
            )}
          </Card.Body>
        </Card>
      </div>
    </Sidebar>
  );
};

export default NetworkLeadershipAcademy;


